import {makeStyles} from "tss-react/mui";

export const useChatbotMessageStyles = makeStyles()((theme) => ({
  listItem: {
    padding: 0,
    marginBottom: theme.spacing(1),
  },
  listItemHuman: {
    justifyContent: "flex-end",
  },
  listItemBot: {
    justifyContent: "flex-start",
  },
  messageBox: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    overflowWrap: "break-word",
    "& p": {
      marginTop: 0,
      marginBottom: theme.spacing(1.5),
      "&:last-child": {
        marginBottom: 0,
      },
    },
    "& ul, & ol": {
      marginTop: 0,
      marginBottom: theme.spacing(1.5),
      paddingLeft: theme.spacing(3),
      "&:last-child": {
        marginBottom: 0,
      },
    },
    "& ul": {
      listStyleType: "disc",
      "& ul": {
        listStyleType: "circle",
        "& ul": {
          listStyleType: "square",
          "& ul": {
            listStyleType: "disc",
            "& ul": {
              listStyleType: "circle",
              "& ul": {
                listStyleType: "square",
              },
            },
          },
        },
      },
    },
    "& ol": {
      listStyleType: "decimal",
      "& ol": {
        listStyleType: "lower-alpha",
        "& ol": {
          listStyleType: "lower-roman",
          "& ol": {
            listStyleType: "upper-alpha",
            "& ol": {
              listStyleType: "upper-roman",
            },
          },
        },
      },
    },
    "& blockquote": {
      borderLeft: `3px solid ${theme.palette.divider}`,
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: theme.spacing(2),
      opacity: 0.9,
    },
    "& table": {
      borderCollapse: "collapse",
      marginBottom: theme.spacing(1.5),
      width: "100%",
    },
    "& th, & td": {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(0.75, 1.5),
      textAlign: "left",
    },
    "& th": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[200],
    },
    "& pre": {
      overflowX: "auto",
      maxWidth: "100%",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
    },
    "& code": {
      maxWidth: "100%",
      wordBreak: "break-word",
      overflowWrap: "break-word",
    },
  },
  messageBoxHuman: {
    maxWidth: "70%",
    backgroundColor: theme.palette.primary.main,
  },
  widgetBox: {
    width: "90%",
    maxWidth: 460,
  },
  widgetSelectPanel: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 1.5),
  },
  widgetUseButton: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  messageBoxBot: {
    maxWidth: "100%",
    overflow: "auto",
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
  },
  textHuman: {
    color: theme.palette.primary.contrastText,
  },
  textBot: {
    color: theme.palette.text.primary,
  },
  abortedMessage: {
    marginTop: theme.spacing(1),
    fontStyle: "italic",
    opacity: 0.7,
    fontSize: "0.875rem",
  },
  activityMessage: {
    fontStyle: "italic",
    opacity: 0.7,
    fontSize: "0.875rem",
  },
  confirmationButtons: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    justifyContent: "flex-end",
  },
  messageToolbar: {
    marginTop: theme.spacing(0.5),
    "@media print": {
      display: "none",
    },
  },
  messageToolbarCopyButton: {
    opacity: 0.7,
    "&:hover": {
      opacity: 1,
    },
  },
}));
